module.exports = __webpack_public_path__ + "img/home_ys_icon.6a88fef.png";